var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Field, Codable, Model } from '@1amageek/ballcap';
import { Base } from '.';
// サブスクリプションプランの機能
export class SubscriptionFeature extends Model {
}
__decorate([
    Field,
    __metadata("design:type", Number)
], SubscriptionFeature.prototype, "constantCost", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], SubscriptionFeature.prototype, "currency", void 0);
__decorate([
    Field,
    __metadata("design:type", Number)
], SubscriptionFeature.prototype, "periodWithMonthly", void 0);
__decorate([
    Field,
    __metadata("design:type", Number)
], SubscriptionFeature.prototype, "trialDays", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], SubscriptionFeature.prototype, "stripePriceId", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], SubscriptionFeature.prototype, "campaign", void 0);
// 成果報酬プランの機能
export class PayPerUseFeature extends Model {
}
__decorate([
    Field,
    __metadata("design:type", Number)
], PayPerUseFeature.prototype, "defaultAmount", void 0);
__decorate([
    Field,
    __metadata("design:type", Number)
], PayPerUseFeature.prototype, "firstTimeAmount", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], PayPerUseFeature.prototype, "currency", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], PayPerUseFeature.prototype, "campaign", void 0);
// 決済機能のマスターデータ
export class PaymentMaster extends Base {
    static collectionReference() {
        return super.collectionReference().doc('v1').collection('paymentMaster');
    }
}
PaymentMaster.documentId = 'v1';
__decorate([
    Field,
    __metadata("design:type", Number)
], PaymentMaster.prototype, "minimumAmountOfHour", void 0);
__decorate([
    Codable(SubscriptionFeature),
    Field,
    __metadata("design:type", SubscriptionFeature
    // 成果報酬プラン機能
    )
], PaymentMaster.prototype, "standardPlanFeature", void 0);
__decorate([
    Codable(PayPerUseFeature),
    Field,
    __metadata("design:type", PayPerUseFeature
    // 使い放題プラン機能
    )
], PaymentMaster.prototype, "performanceRewardPlanFeature", void 0);
__decorate([
    Codable(SubscriptionFeature),
    Field,
    __metadata("design:type", SubscriptionFeature)
], PaymentMaster.prototype, "professionalPlanFeature", void 0);
